import React from "react";

const EmbedWithCaptionHOC = (Component) => {
  const WrappedComponent = ({ caption, ...props }) => {
    return (
      <figure className="embed-container">
        <Component {...props} />
        {caption && (
          <figcaption
            dangerouslySetInnerHTML={{ __html: caption }}
          ></figcaption>
        )}
      </figure>
    );
  };

  return WrappedComponent;
};

export default EmbedWithCaptionHOC;
